<template>
  <div class="content">
    <main>
      <section>
        <h2>Herzlich willkommen!</h2>
        <img class="full" src="@/assets/home.jpg" alt="Das Gästehaus">
      </section>
    </main>

    <aside id="announcement" title="Ankündigung">
      <section>
          <h2>E-Mail</h2>
          <p>Sie erreichen uns unter <a href="mailto:erna.schwengerer@aon.at">erna.schwengerer@aon.at</a>.</p>
      </section>
      <section>
          <h2>Telefonisch</h2>
          <p>Gerne können Sie uns auch telefonisch unter <a href="tel:+4333364513">+43&nbsp;3336&nbsp;4513</a> kontaktieren.</p>
      </section>
    </aside>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Home',
}
</script>

<style lang="scss" scoped>
  img {
    max-width: 100%;
  }

  aside a {
    text-decoration: none;
    font-weight: bold;
    color: black;
}
</style>